import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { useNavigate } from "react-router-dom"; 
import FRONTEND_CONFIG from "./frontend_config";




export default function QuestionBank() {
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const filterMenuRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);

const navigate = useNavigate(); 
const [importing, setImporting] = useState(false); 

const [showCreateModal, setShowCreateModal] = useState(false);
const handleImport = async (e) => {
  const file = e.target.files && e.target.files[0];
  if (!file) return;

  try {
    setImporting(true);

    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer);
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" }); 

    if (!rows || rows.length === 0) {
      alert("No rows found in the file.");
      return;
    }

   
    for (const row of rows) {
      
      const optionsRaw = (row.options || "").toString();
      const optionsArr = optionsRaw
        .split("|")
        .map((o) => o.trim())
        .filter(Boolean);

      const payload = {
        questionText: row.question || row.questionText || "",
        options: optionsArr.map((opt) => ({ optionText: opt })),
        correctAnswer: row.correctAnswer || "",
        marks: row.marks || 1,
        subject: row.subject || "",
        level: row.level || "",
        chapter: row.topic || row.chapter || "",
        class: row.className || row.class || "",
        createdBy: "671d8d9c0b6e8a9e145efbc2",
      };


      if (!payload.questionText || payload.options.length === 0) {
        console.warn("Skipping row missing question or options:", row);
        continue;
      }

      try {
        
        await axios.post(`${FRONTEND_CONFIG.API_URL}/api/question/add-question`, payload);
      } catch (err) {
        console.error("Failed to save row to backend", err, row);
        // continue to next row; you may collect failures to show later
      }
    }

    alert("✅ Import complete.");
    const res = await axios.get(`${FRONTEND_CONFIG.API_URL}/api/question/all-question`);
    setQuestions(res.data);
    setFilteredQuestions(res.data);
  } catch (err) {
    console.error(err);
    alert("❌ Import failed: " + (err.message || ""));
  } finally {
    setImporting(false);
    e.target.value = "";
  }
};
const handleExport = () => {
  if (!questions || questions.length === 0) {
    alert("No questions to export.");
    return;
  }

  const formatted = questions.map((q) => ({
    className: q.class || "",
    subject: q.subject || "",
    topic: q.chapter || "",
    level: q.level || "",
    question: q.questionText || "",
    options: (q.options || []).map((o) => (o.optionText ? o.optionText : o)).join("|"),
    correctAnswer: q.correctAnswer || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(formatted);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Questions");
  XLSX.writeFile(workbook, "QuestionBank.xlsx");
};

  const [filterEnabled, setFilterEnabled] = useState({
    class: false,
    subject: false,
  });
  const toggleSelectRow = (id) => {
  setSelectedRows((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
};
const handleDeleteSelected = async () => {
  if (selectedRows.length === 0) return;
  if (!window.confirm("Are you sure you want to delete selected questions?")) return;

  try {
    await axios.post(`${FRONTEND_CONFIG.API_URL}/api/question/delete-multiple`, {
      ids: selectedRows,
    });

    const updated = questions.filter((q) => !selectedRows.includes(q._id));
    setQuestions(updated);
    setFilteredQuestions(updated);
    setSelectedRows([]);
  } catch (err) {
    alert("❌ Failed to delete selected questions");
  }
};
//For Filter
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);

  const [showFilterMenu, setShowFilterMenu] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [questionsPerPage] = useState(5);
  const [editing, setEditing] = useState({ id: null, field: "", value: "" });

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const res = await axios.get(`${FRONTEND_CONFIG.API_URL}/api/question/all-question`);
        setQuestions(res.data);
        setFilteredQuestions(res.data);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };
    fetchQuestions();
  }, []);
  useEffect(() => {
  function handleClickOutside(event) {
    if (filterMenuRef.current && !filterMenuRef.current.contains(event.target)) {
      setShowFilterMenu(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  // Apply search + active filters
  useEffect(() => {
    let data = [...questions];

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      data = data.filter(
        (q) =>
          q.questionText?.toLowerCase().includes(term) ||
          q.subject?.toLowerCase().includes(term) ||
          q.chapter?.toLowerCase().includes(term)
      );
    }

    // If Class filter enabled and some selected classes exist -> filter by them
    if (filterEnabled.class && selectedClasses.length > 0) {
      data = data.filter((q) => selectedClasses.includes(q.class));
    }

    // If Subject filter enabled and some selected subjects exist -> filter by them
    if (filterEnabled.subject && selectedSubjects.length > 0) {
      data = data.filter((q) => selectedSubjects.includes(q.subject));
    }

    setFilteredQuestions(data);
    setCurrentPage(1);
  }, [searchTerm, filterEnabled, selectedClasses, selectedSubjects, questions]);

  // When a top-level toggle changes to false, clear its selected values
  const toggleFilterSection = (section) => {
    setFilterEnabled((prev) => {
      const next = { ...prev, [section]: !prev[section] };
      // if turning off, clear selections for that section
      if (!next[section]) {
        if (section === "class") setSelectedClasses([]);
        if (section === "subject") setSelectedSubjects([]);
      }
      return next;
    });
  };

  const toggleClassValue = (cls) => {
    setSelectedClasses((prev) => (prev.includes(cls) ? prev.filter((c) => c !== cls) : [...prev, cls]));
  };

  const toggleSubjectValue = (sub) => {
    setSelectedSubjects((prev) => (prev.includes(sub) ? prev.filter((s) => s !== sub) : [...prev, sub]));
  };

  // Inline edit handlers (kept from your original code)
  const handleDoubleClick = (qId, field, value) => {
    setEditing({ id: qId, field, value });
  };

  const handleChange = (e) => {
    setEditing({ ...editing, value: e.target.value });
  };

  const handleSave = async () => {
    const { id, field, value } = editing;
    if (!id || !field) return;
    try {

       await axios.put(`${FRONTEND_CONFIG.API_URL}/api/question/update-question/${id}`, {

        [field]: value,
      });
      const updated = questions.map((q) => (q._id === id ? { ...q, [field]: value } : q));
      setQuestions(updated);
      setFilteredQuestions(updated);
    } catch (error) {
      console.error("Error updating question:", error);
      alert("❌ Failed to update question");
    } finally {
      setEditing({ id: null, field: "", value: "" });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSave();
  };

  // Pagination
  const indexOfLast = currentPage * questionsPerPage;
  const indexOfFirst = indexOfLast - questionsPerPage;
  const currentQuestions = filteredQuestions.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.max(1, Math.ceil(filteredQuestions.length / questionsPerPage));

  // Helpers to get unique lists (guard empty values)
  const classesList = [...new Set(questions.map((q) => q.class).filter(Boolean))];
  const subjectsList = [...new Set(questions.map((q) => q.subject).filter(Boolean))];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-6 relative">
      <div className="max-w-7xl mx-auto bg-white shadow-2xl rounded-2xl p-8 border border-blue-100 relative">
        <h2 className="text-3xl font-extrabold text-center text-blue-800 mb-8 tracking-wide">
          🧠 Examination Cell – Question Bank
        </h2>

        {/* Search + Filter Button */}
        <div className="flex justify-between items-center mb-6">
          <input
            type="text"
            placeholder="🔍 Search by question, subject or chapter..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-1/3 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400"
          />

          <div className="relative">
            <button
              onClick={() => setShowFilterMenu((s) => !s)}
              className="px-5 py-2 bg-pink-500 text-white rounded-lg shadow-md hover:bg-pink-600"
            >
              ⚙ Filter
            </button>

            {/* Dropdown menu */}
            {showFilterMenu && (
              <div ref={filterMenuRef} className="absolute right-0 mt-3 bg-white shadow-xl rounded-xl border p-4 w-72 z-50">

                {/* Top-level toggles */}
                <div className="space-y-2">
                  <label className="flex items-center justify-between cursor-pointer">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={filterEnabled.class}
                        onChange={() => toggleFilterSection("class")}
                        className="accent-pink-500"
                      />
                      <span className="text-sm font-medium text-gray-700">Class</span>
                    </div>
                    {/* drag handle-like dots (decorative) */}
                    <div className="text-gray-300">⋮⋮</div>
                  </label>

                  {/* values for class appear only if top-level class is enabled */}
                  {filterEnabled.class && (
                    <div className="max-h-28 overflow-y-auto border rounded-lg p-2">
                      {classesList.length === 0 ? (
                        <div className="text-xs text-gray-400">No classes</div>
                      ) : (
                        classesList.map((cls) => (
                          <label key={cls} className="flex items-center gap-2 text-sm py-1 cursor-pointer">
                            <input
                              type="checkbox"
                              className="accent-pink-500"
                              checked={selectedClasses.includes(cls)}
                              onChange={() => toggleClassValue(cls)}
                            />
                            {cls}
                          </label>
                        ))
                      )}
                    </div>
                  )}

                  <hr className="my-2" />

                  <label className="flex items-center justify-between cursor-pointer">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={filterEnabled.subject}
                        onChange={() => toggleFilterSection("subject")}
                        className="accent-pink-500"
                      />
                      <span className="text-sm font-medium text-gray-700">Subject</span>
                    </div>
                    <div className="text-gray-300">⋮⋮</div>
                  </label>

                  {filterEnabled.subject && (
                    <div className="max-h-28 overflow-y-auto border rounded-lg p-2">
                      {subjectsList.length === 0 ? (
                        <div className="text-xs text-gray-400">No subjects</div>
                      ) : (
                        subjectsList.map((sub) => (
                          <label key={sub} className="flex items-center gap-2 text-sm py-1 cursor-pointer">
                            <input
                              type="checkbox"
                              className="accent-pink-500"
                              checked={selectedSubjects.includes(sub)}
                              onChange={() => toggleSubjectValue(sub)}
                            />
                            {sub}
                          </label>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
            {selectedRows.length > 0 && (
  <button
    onClick={handleDeleteSelected}
    className="mb-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition"
  >
    Delete Selected ({selectedRows.length})
  </button>
)}
  <div className="flex items-center justify-between gap-3 mb-4">
  {/* Left: New Question */}
  <div className="flex items-center gap-2">
    {/* OPTION A: navigate to CreateQuestion route */}
    <button
      onClick={() => navigate("/create-question")}
      className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
    >
      + New 
    </button>
  </div>

  {/* Right: Import and Export */}
  <div className="flex items-center gap-2">
    <input
      type="file"
      accept=".csv, .xlsx"
      onChange={handleImport}
      className="border px-3 py-2 rounded-lg cursor-pointer"
    />

    <button
      onClick={handleExport}
      className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
    >
      Export
    </button>
  </div>
</div>

        {/* Table */}
        <div className="overflow-x-auto rounded-xl shadow-lg border border-blue-200">
          <table className="w-full text-sm text-left border-collapse">
            <thead className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
  <tr>
    <th className="p-4 border-r border-blue-500 text-center">
      <input
        type="checkbox"
        onChange={(e) =>
          setSelectedRows(
            e.target.checked ? filteredQuestions.map((q) => q._id) : []
          )
        }
        checked={
          selectedRows.length > 0 &&
          selectedRows.length === filteredQuestions.length
        }
        className="accent-pink-500"
      />
    </th>
    <th className="p-4 border-r border-blue-500 text-center">Q.ID</th>
    <th className="p-4 border-r border-blue-500">Question</th>
    <th className="p-4 border-r border-blue-500">Subject</th>
    <th className="p-4 border-r border-blue-500">Chapter</th>
    <th className="p-4 border-r border-blue-500">Class</th>
    <th className="p-4 text-green-100">Correct Answer</th>
  </tr>
</thead>

            <tbody>
              {currentQuestions.length > 0 ? (
                currentQuestions.map((q, idx) => (
                  <tr
  key={q._id || idx}
  className={`transition-all border-b border-blue-100 hover:bg-blue-50 ${
    idx % 2 === 0 ? "bg-white" : "bg-blue-50/60"
  }`}
>
  {/* ✅ Checkbox */}
  <td className="p-3 text-center border-r border-gray-200">
    <input
      type="checkbox"
      checked={selectedRows.includes(q._id)}
      onChange={() => toggleSelectRow(q._id)}
      className="accent-pink-500"
    />
  </td>

  {/* ✅ QID COLUMN ADDED */}
  <td className="p-3 border-r border-gray-200 text-xs text-gray-600">
    {q.questionId || q.questionId}   {/* If you have custom qid field use q.qid */}
  </td>

  {/* ✅ Existing mapped fields */}
  {["questionText", "subject", "chapter", "class", "correctAnswer"].map((field, i) => (
    <td
      key={field}
      className={`p-3 border-r border-gray-200 cursor-pointer ${
        i === 4 ? "text-green-700 font-medium" : ""
      }`}
      onDoubleClick={() => handleDoubleClick(q._id, field, q[field] || "")}
    >
      {editing.id === q._id && editing.field === field ? (
        <input
          type="text"
          value={editing.value}
          onChange={handleChange}
          onBlur={handleSave}
          onKeyDown={handleKeyPress}
          className="w-full border border-blue-400 bg-white rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
          autoFocus
        />
      ) : (
        <span className="block truncate">{q[field]}</span>
      )}
    </td>
  ))}
</tr>

                ))
              ) : (
                <tr>
                  <td colSpan="6" className="p-5 text-center text-gray-500">
                    No questions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center mt-8 gap-4">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            className={`px-4 py-2 rounded-lg shadow-md bg-blue-600 hover:bg-blue-700 text-white disabled:bg-gray-300`}
          >
            ⬅ Prev
          </button>

          <span className="text-gray-700 font-medium">
            Page <b>{currentPage}</b> of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            className={`px-4 py-2 rounded-lg shadow-md bg-blue-600 hover:bg-blue-700 text-white disabled:bg-gray-300`}
          >
            Next ➡
          </button>
        </div>
      </div>
    </div>
  );
}
